export default {"src":"/_next/static/media/window-casement.07ad0c67.svg","height":1000,"width":1000};